/**
 * Component Registry for Pillar Properties Theme
 * 
 * Extends the base avenue theme registry with Pillar Properties specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-avenue/registry';
import { Footer } from './components/Footer';
import { FloorplansList } from './components/FloorplansList';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { SocialFollow } from './components/SocialFollow';

/**
 * Pillar Properties specific component overrides.
 * These components have been customized for the Pillar Properties brand.
 */
const pillarpropertiesOverrides: Partial<ComponentRegistry> = {
  Footer,
  FloorplansList,
  Header,
  Hero,
  SocialFollow,
};

/**
 * Final merged registry for Pillar Properties properties.
 * Inherits all components from the avenue theme, with Pillar Properties overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...pillarpropertiesOverrides,
};

export default registry;
